export default (value = '') => {
    return value ? value.replace(/\s{2,}/g, "&nbsp;") : ''
}